import React from "react";
import Button from "components/Form/fields/Button";
import { BUTTON_CLASS_CONTEXT, UI_THEME } from "utils/constants/ui";
import { getIconForUID } from "components/FormerEditor/utils";
/**
 * Attempt to refetch security creds for image upload
 * @param {Object} params
 * @param {Function} params.onClick
 */
const UploadError = ({ onClick, prompt }) => {
  const AlertIcon = getIconForUID("alert");

  return (
    <div className="w-100 flex flex-column items-center justify-center tc pa3">
      <AlertIcon size={28} />
      <div className="f5 pt2">{prompt.header}</div>
      <div className="f6 pt2 pb3">{prompt.subheader}</div>
      <Button
        theme={UI_THEME.SLIM}
        classes={{
          contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
        }}
        onClick={onClick}
        copy="Refresh"
      />
    </div>
  );
};

export default UploadError;
